import { Injectable, Inject } from '@angular/core';
import {APP_SETTINGS } from '../../../modules/ng-express-engine/tokens';
import { Observable } from 'rxjs';
import { DataService } from '../../service/data';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { StateInternalPipe } from './state-internal.pipe';
import { StateDataPipe } from './state-data.pipe';
import { Subscription } from 'rxjs/Subscription'; 
import { Actions, Effect } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import * as fromRoot from '../reducer/core.reducer';
import * as coreActions from '../action/core.actions';

@Injectable()
export class StateSearchPipe {

    public searchSubscription: Subscription;
    public moreResultsSubscription: Subscription;
    public firstRowSubscription: Subscription;
    public getFilterParkedRowSubscription: Subscription;


    constructor(
        @Inject(APP_SETTINGS) private settings: Object,
        private store: Store<fromRoot.State>,
        private actions$: Actions,
        private apiService: DataService,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private stateInternal: StateInternalPipe,
        private stateData: StateDataPipe
    ) { 

    }

    public searchEntries(term) {
        return (term) ? this.searchByTerm(term.toLowerCase(), true) : Observable.of<any>([])        
    }


    public searchByTerm(term: string, trimResults: boolean) : Observable<any> {
        if (term.length < 3) return Observable.of<any>([]);
        const url = this.settings['DATA_API_ENDPOINT'] + '/search'; 
        return this.apiService.getDataWithPathElement(term, url)
            .map(results => this.processSearchResults(results));    
    }

    private processSearchResults(results: Object){
        let i = 0;
        let bucket = [];
        if (results['rows'] && Array.isArray(results['rows'])){
            for (let row of results['rows']){
            if (row['meta'] && row['meta']['next_page_url']){
                const url = row['meta']['next_page_url'].trim();
                if (url && url.length > 10){
                if (i<100){
                    //this.store.dispatch(new coreActions.LoadDataItemAction({ routeParams: {}, apiUrl: row['meta']['next_page_url'] }));
                    bucket.push(this.getApiData({}, url, 0, true, true, false));
                    //bucket.push(this.apiService.getData({}, url, 0, true, true, false));
                }
                i++;
                } 
            }
            row = this.stateInternal.getRowMetaFlags(row, this.router.url, {});
            }
        }
        if (bucket.length > 0){
            if (this.searchSubscription){
                this.searchSubscription.unsubscribe();
            }
            this.searchSubscription = Observable.forkJoin(bucket).subscribe(); //leak handled
        }
        
        const decoratedRes = this.stateInternal.getRowMetaFlags(results, this.router.url, {});
        return decoratedRes;
    }

    public moreResultsBySearchTermAndCategory(row: Object){
        const rowCount = row['data'].length;
        const rowTotalCount = (row['total_count']) ? row['total_count'] : row['meta']['total_count'];
        if (row['meta'] && row['meta'][this.settings['NEXT_PAGE_URL']]){
            const cleanUrl =  row['meta'][this.settings['NEXT_PAGE_URL']].replace(this.settings['DATA_API_ENDPOINT'],'');
            let storeKey = cleanUrl.slice(0, cleanUrl.indexOf('?'));
            storeKey = storeKey.replace("//", "/");
            const nextSet =  JSON.parse(JSON.stringify(this.stateData.getStaticRouteData(storeKey, {})));
            Object.assign({}, this.stateData.getStaticRouteData(storeKey, {}));
            if(nextSet['meta'] && nextSet['meta'][this.settings['NEXT_PAGE_URL']]){
                const url = nextSet['meta']['next_page_url'].trim();
                if (url && url.length > 10){
                    if (this.moreResultsSubscription){
                        this.moreResultsSubscription.unsubscribe();
                    }      
                    const self = this;   
                    console.log(url);   
                    //this.moreResultsSubscription = this.apiService.getData({}, url, 0, true, true, false).subscribe(); //leak handled
                    setTimeout(function() {
                        this.moreResultsSubscription = self.getApiData({}, url, 0, true, true, false).subscribe();
                    },0);
                    
                }         
            }
//             let result = {};//Object.assign({}, row);
//             result['meta'] = nextSet['meta'];
//             result['data'] = nextSet['data'];
            const sliceSize = (rowTotalCount - rowCount >= this.settings['SEARCH_CATEGORY_LIMIT']) ? this.settings['SEARCH_CATEGORY_LIMIT'] : rowTotalCount - rowCount;
            nextSet['data'] = this.lastNFromArray(nextSet['data'], sliceSize);
            const decoratedResult = this.stateInternal.getRowMetaFlags(nextSet, this.router.url, {});
            return decoratedResult;
        }
        return row;
    }

    private lastNFromArray(array, n) {
        if (array == null && n == null) {
            return [];
        }
        return array.slice(Math.max(array.length - n, 0));  
    }

    public removeSearchData(){
        this.store.dispatch(new coreActions.RemoveSearchData({ }));
    }

    public storeSearchSectionFirstRowOnHide(sectionName: string, searchTerm: string){
        const url = this.settings['DATA_API_ENDPOINT'] + '/search/'  + sectionName + '/' + searchTerm; 
        if (this.firstRowSubscription){
            this.firstRowSubscription.unsubscribe();
        }
        this.firstRowSubscription = this.getApiData({}, url, 0, true, true, false).subscribe(); //leak handled
        //this.firstRowSubscription = this.apiService.getData({}, url, 0, true, true, false).subscribe();
    }

    public getSearchSectionFirstRowOnShow(sectionName: string, searchTerm: string){
        const storeKey = '/search/' + sectionName + '/' + searchTerm; 
        const row =  Object.assign({}, this.stateData.getStaticRouteData(storeKey, {}));
        if (row['meta'] && row['meta'][this.settings['NEXT_PAGE_URL']]){
        const url =  row['meta'][this.settings['NEXT_PAGE_URL']];
            if (url && url.length > 10){
                if (this.getFilterParkedRowSubscription){
                    this.getFilterParkedRowSubscription.unsubscribe();
                }
                this.getFilterParkedRowSubscription = this.getApiData({}, url, 0, true, true, false).subscribe();
                //this.getFilterParkedRowSubscription = this.apiService.getData({}, url, 0, true, true, false).subscribe(); //leak handled
            }         
        }
        return row;
    }    

    private getApiData(routeParams: Object, apiUrl: string, numRetries?: number, dispatch?: boolean, isSlug?: boolean, asyncChildren?: boolean){
        apiUrl = apiUrl.replace(this.settings['DATA_API_ENDPOINT'], "")
        apiUrl = apiUrl.replace("//", "/");  
        if (apiUrl.indexOf(this.settings['DATA_API_ENDPOINT']) < 0){
            apiUrl = this.settings['DATA_API_ENDPOINT'] + apiUrl;
        }
        return this.apiService.getData(routeParams, apiUrl, numRetries, dispatch, isSlug, asyncChildren);
    }

}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/state/effect/state-search.pipe.ts